<template>
  <generic-modal
    size="large"
    :title="$t('custom signature configuration')"
    icon="settings"
    image="/images/icons/quotation.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <generic-container
        icon="signature"
        :show_plus="true"
        :title="$t('signatures')"
        class="ui basic segment"
        @add="add_template"
      >
        <div class="ui grid">
          <div class="four wide column">
            <div
              class="ui vertical fluid pointing menu"
              ref="tabs_billing"
              v-if="billing_templates && billing_templates.length"
            >
              <a
                class="item"
                :data-tab="'b' + idx"
                v-for="(lyt, idx) in billing_templates"
                :key="idx"
              >
                <i
                  class="settings icon"
                  :class="{ blue: lyt.setup.set_as_default }"
                ></i>
                {{ lyt.name || $t("unnamed") }}
              </a>
            </div>
          </div>
          <div class="twelve wide stretched column">
            <div
              class="ui tab segment"
              :data-tab="'b' + idx"
              v-for="(tpl, idx) in billing_templates"
              :key="idx"
              style="margin-top:0"
            >
              <div class="ui two item top attached tabular menu">
                <a class="active item" data-tab="certifier">
                  <i class="info icon"></i>
                  {{ $t("general info") }}</a
                >
                <a class="item" data-tab="receipt">
                  <i class="file invoice icon"></i> {{ $t("template") }}</a
                >
              </div>
              <div
                class="ui bottom attached active tab segment"
                data-tab="certifier"
              >
                <div class="ui form">
                  <div class="two fields">
                    <div class="field">
                      <label for>{{ $t("name") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="billing_templates[idx].name"
                      />
                    </div>
                    <div class="field">
                      <label for>
                        <i class="settings icon"></i>
                      </label>
                      <div
                        class="ui toggle checkbox"
                        :data-idx="idx"
                        ref="set_as_default_checkbox"
                      >
                        <input
                          type="checkbox"
                          name="set_as_default"
                          v-model="billing_templates[idx].setup.set_as_default"
                        />
                        <label>{{ $t("set as default") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui bottom attached tab segment" data-tab="receipt">
                <wysywyg v-model="billing_templates[idx].setup.template" />
              </div>
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";
import { v4 } from "uuid";
import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "FelGtConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    Wysywyg,
  },
  computed: {},
  data() {
    return {
      billing_templates: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        // let settings = vm.settings;
        local_api(vm, "post", "/quotation/do-save-signatures", {
          signatures: vm.billing_templates,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    add_template() {
      let template = {
        uuid: v4(),
        name: "",
        setup: {
          set_as_default: false,
          template: {
            css: "",
            js: "",
            html: "",
          },
        },
      };
      this.billing_templates.push(template);
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/quotation/do-get-signatures")
      .then((signatures) => {
        console.log(signatures);
        vm.billing_templates = signatures;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {
    billing_templates() {
      let vm = this;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs_billing)
          .find(".item")
          .tab();

        window.jQuery(vm.$refs.set_as_default_checkbox).checkbox({
          onChecked() {
            let trgtIndex = window
              .jQuery(this)
              .closest(".checkbox")
              .data("idx");
            vm.billing_templates.map((b) => {
              b.setup.set_as_default = false;
            });
            vm.billing_templates[trgtIndex].setup.set_as_default = true;
          },
        });

        window.jQuery(".ui.tabular.menu .item").tab();
      }, 500);
    },
  },
  updated: function() {},
};
</script>
